module.exports = __webpack_public_path__ + "static/media/twitch.36937bf0.png";